import { lazy, ReactElement } from 'react';
import { RouteObject } from "react-router-dom";
import { Sparkles, MessageCircle, Settings as SettingsIcon } from "lucide-react";

// Lazy load pages
const SetupPage = lazy(() => import('../pages/SetupPage'));
const DiscoverPage = lazy(() => import('../pages/DiscoverPage'));
const MyConversationsPage = lazy(() => import('../pages/MyConversationsPage'));
const ActiveConversationPage = lazy(() => import('../pages/ActiveConversationPage'));
const SettingsPage = lazy(() => import('../pages/SettingsPage'));
const NotFound = lazy(() => import('../pages/NotFound404'));

const routes = [
  // Main app routes - no auth required since this is explicitly set to requiresAuth: false
  { path: '/', element: <DiscoverPage /> },
  { path: '/setup', element: <SetupPage /> },
  { path: '/conversations', element: <MyConversationsPage /> },
  { path: '/conversation/:id', element: <ActiveConversationPage /> },
  { path: '/settings', element: <SettingsPage /> },
  
  // Fallback
  { path: '*', element: <NotFound /> },
] as const;

export const routesExcludedFromSidebar = ['/setup', '/conversation/:id', '*'] as const;

// This type ensures that the paths are a valid top level path
type AllRoutes = typeof routes[number]['path']
type RoutesExcludedFromSidebar = typeof routesExcludedFromSidebar[number]
export type ValidSidebarPath = Exclude<AllRoutes, RoutesExcludedFromSidebar>;

export const sidebarRoutes = [
  { path: '/', title: 'Discover', icon: <Sparkles />, breadcrumb: { section: 'App', page: 'discover' } },
  { path: '/conversations', title: 'My Conversations', icon: <MessageCircle />, breadcrumb: { section: 'App', page: 'conversations' } },
  { path: '/settings', title: 'Settings', icon: <SettingsIcon />, breadcrumb: { section: 'App', page: 'settings' } },
] satisfies Array<{ 
  title: string; 
  path: ValidSidebarPath; 
  icon: ReactElement;
  breadcrumb: { section: string; page: string };
}>;

export default [...routes] satisfies RouteObject[]